import React from "react";
import { observer } from "mobx-react-lite";

import FormField from "../form-field/FormField";
import { dateService } from "../../services/date-service/DateService";

interface Deadline {
  date: string | Date | null;
}

export default observer(function DisplayDeadline(props: Deadline) {
  return (
    <FormField
      id="deadline"
      labelKey="general.deadline"
      readOnly
      fieldValue={props.date ? dateService.formatDate(props.date) : "-"}
    />
  );
});
